export const INDEX = "index";
export const LOGIN = "login";
export const HOME = "home";
export const VERSION_CONTROL_INDEX = "versionControl";
